// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a9aa03f5","977":"4503f907"}[chunkId] + ".chunk.js";
};